<div class="input input-text" [style.margin-bottom]="displayErrors ? 0 : messagePad" [style.width]="width">
  <div [ngClass]="{ 'p-field': true, left: labelPositionLeft }">
    <label [for]="name" [style.width]="labelWidth">{{ label }}</label>
    <div [style.width]="inputWidth">
      <input
        #model="ngModel"
        appReadOnly
        [(ngModel)]="value"
        (ngModelChange)="onChange($event)"
        [id]="name"
        [attr.name]="name"
        [type]="type"
        [attr.min]="min"
        [attr.max]="max"
        [attr.step]="step"
        [attr.data-cy]="dataCy"
        [placeholder]="placeholder"
        [required]="required"
        [disabled]="isDisabled"
        [class.dirty]="dirty"
        (blur)="onBlur()"
        (focus)="onFocusInput()"
        (keypress)="onInputKeyDown($event)"
        (keyup.escape)="onEsc()"
        [class.has-errors]="displayErrors"
        [attr.aria-invalid]="displayErrors"
        [attr.aria-describedby]="displayErrors ? name + '-error' : null"
        [tabindex]="tabindex"
        pInputText
        [ignoreReadOnly]="ignoreReadOnly"
        #input
      />
      <div class="error-container" *ngIf="displayErrors" [attr.id]="name + '-error'" role="alert" aria-atomic="true">
        <span *ngFor="let error of errors" class="p-error">{{ error }}</span>
      </div>
    </div>
  </div>
</div>
